import {
  CalendarEventResponse,
  CalendarEventId,
  CalendarEventRequest,
  CreateCalendarEventResponse,
  MoveCalendarEventRequest,
  CalendarEventUserResponse, CalendarEventUserId
} from '@business/entities/calendar_event';
import { Endpoint } from '../endpoint';
import { CommonService } from "@business/services";
import { CalendarEvent } from "@modules/common/Calendar";

export function fetchEvents(request: CalendarEventRequest) {
  return Endpoint.post<CalendarEventResponse[]>(`@gc/calendar-events/fetch`, { data: request });
}

export function createEvent(event: Partial<CreateCalendarEventResponse>) {
  const formData = CommonService.toFormData(event);
  return Endpoint.post<CalendarEventResponse>(`@gc/calendar-events`, { formData, hasFiles: true });
}

export function updateEvent(id: CalendarEventId, event: Partial<CreateCalendarEventResponse>) {
  const formData = CommonService.toFormData(event);
  return Endpoint.post<CalendarEventResponse>(`@gc/calendar-events/update/${id}`, { formData, hasFiles: true });
}

export function moveEvent(id: CalendarEventId, request: MoveCalendarEventRequest) {
  return Endpoint.post<CalendarEventResponse>(`@gc/calendar-events/move/${id}`, { data: request });
}

export function deleteEvent(eventId: CalendarEventId) {
  return Endpoint.delete<void>(`@gc/calendar-events/${eventId}`);
}

export function updateEventUserTask(eventUserId: CalendarEventUserId, isAdmin: boolean) {
  return Endpoint.patch<CalendarEventResponse>(`@gc/calendar-events/event-user-task/${eventUserId}`, { data: { isAdmin } });
}
